/** Unidades de venda do produto (cadastro / Caixa). */
export const UNIDADES_VENDA = [
  { value: "unidade", label: "Unidade", caixaLabel: "Quantidade" },
  { value: "quilo", label: "Quilo", caixaLabel: "Quilos" },
  { value: "grama", label: "Grama", caixaLabel: "Gramas" },
  { value: "litro", label: "Litro", caixaLabel: "Litros" },
  { value: "mililitro", label: "Mililitro", caixaLabel: "Mililitros" },
] as const;

export type UnidadeVenda = (typeof UNIDADES_VENDA)[number]["value"];

export function normalizarUnidadeVenda(raw: string | null | undefined): UnidadeVenda {
  const v = (raw ?? "").trim().toLowerCase();
  const aliases: Record<string, UnidadeVenda> = {
    un: "unidade",
    und: "unidade",
    unit: "unidade",
    // Legado: fatia usava quantidade inteira — migrar para unidade
    fatia: "unidade",
    fatias: "unidade",
    kg: "quilo",
    quilograma: "quilo",
    g: "grama",
    gramas: "grama",
    l: "litro",
    lt: "litro",
    litros: "litro",
    ml: "mililitro",
    mililitros: "mililitro",
  };
  const mapped = aliases[v] ?? (v as UnidadeVenda);
  return UNIDADES_VENDA.some((u) => u.value === mapped) ? mapped : "unidade";
}

export function unidadeVendaPermiteDecimal(unidade: string | null | undefined): boolean {
  const u = normalizarUnidadeVenda(unidade);
  return u === "quilo" || u === "grama" || u === "litro" || u === "mililitro";
}

export function labelQuantidadeCaixa(unidade: string | null | undefined): string {
  const u = normalizarUnidadeVenda(unidade);
  return UNIDADES_VENDA.find((x) => x.value === u)?.caixaLabel ?? "Quantidade";
}
